// src/context/ToastContext.jsx
// Thin wrapper over react-hot-toast so pages keep using useToast().
// Brand styling is applied once on the Toaster.

import React from "react";
import { Toaster, toast as hot } from "react-hot-toast";

const toast = {
  success: (m) => hot.success(m),
  error: (m) => hot.error(m),
  info: (m) => hot(m),
};

export function ToastProvider({ children }) {
  return (
    <>
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3500,
          style: {
            fontFamily: "Comfortaa, system-ui, sans-serif",
            fontSize: "14px",
            borderRadius: "12px",
            padding: "10px 14px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
          },
          success: { iconTheme: { primary: "#22D3B2", secondary: "#061322" } },
          error: { iconTheme: { primary: "#dc2626", secondary: "#fff" } },
        }}
      />
    </>
  );
}

// pages call: const toast = useToast(); toast.success("Saved");
export const useToast = () => toast;